import { type RequirementIdentifier, type TranslationIDs, useIntl, useSettings } from '@capsicum/common';

type DeniedRequirementMessage = {
	description: TranslationIDs;
	link?: string;
	title?: TranslationIDs;
};

export type DeniedRequirementMessages = Partial<{
	[key in RequirementIdentifier]: DeniedRequirementMessage;
}> & { default: DeniedRequirementMessage };

export const useGetDeniedRequirementMessage = () => {
	const { $t } = useIntl();
	const { settings } = useSettings();

	const DENIED_REQUIREMENT_MESSAGE: DeniedRequirementMessages = {
		default: {
			description: 'jurisdictionRequirements.genericDeniedRequirement.message',
			title: 'jurisdictionRequirements.genericDeniedRequirement.title'
		},
		self_categorisation: {
			description: 'jurisdictionRequirements.deniedRequirement.ukSelfCategorisation.message',
			link: settings?.contactUsHereLink
		}
	};

	const getDeniedRequirementMessage = (deniedRequirements: Array<RequirementIdentifier> | undefined) => {
		const deniedRequirementIdentifier = deniedRequirements?.[0] || 'default';
		const deniedRequirementMessage =
			DENIED_REQUIREMENT_MESSAGE[deniedRequirementIdentifier] || DENIED_REQUIREMENT_MESSAGE.default;

		const title = deniedRequirementMessage.title ? $t(deniedRequirementMessage.title) : '';

		return { description: deniedRequirementMessage.description, link: deniedRequirementMessage.link, title };
	};

	return {
		getDeniedRequirementMessage
	};
};
